<template>
    <v-data-table :headers="headers" :items="commodity_details">
        <template v-slot:[`item.剪辑`]="{ item }">
            <v-btn :disabled="!item['录制ID']" @click="handleEdit(item['录制ID'],item['report_time'])">
                剪辑
            </v-btn>
        </template>
        <template v-slot:[`item.current_commodity`]="{ item }">
            <span v-html="item.current_commodity"></span>
        </template>
    </v-data-table>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps({
    commodity_details: Array
})

const headers = [
    { title: '达人昵称', key: 'talent_nickname', sortable: true },
    { title: '正在讲解时间', key: 'report_time', sortable: true },
    { title: '商品信息', key: 'current_commodity' },
    { title: '在线人数', key: 'online_num', sortable: true },
    { title: '已录制', key: '已录制', sortable: true },
    { title: '剪辑', key: '剪辑', sortable: false }
];

const router = useRouter();

const handleEdit = (transcription_id, explain_t) => {
    //跳到剪辑页面
    // 使用router.resolve获取目标路由的完整URL，并附加查询参数
    const baseHref = router.resolve('kol/para').href;
    const hrefWithParam = `${baseHref}?tid=${transcription_id}&jtime=${explain_t}`;

    // 创建一个新的<a>元素，设置href和target，然后模拟点击
    const link = document.createElement('a');
    link.href = hrefWithParam;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}



</script>

<style scoped>
.bold-and-centered {
    text-align: center;
    font-weight: bold;
}
</style>